import * as React from 'react';
import { SVGProps } from 'react';

const SvgNewTeam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#newTeam_svg__a)' fill='#000'>
      <path d='M16.69 4h1.103v5.517H16.69z' />
      <path d='M14.482 7.31V6.207H20V7.31zM16.138 19.448h-1.104v-1.103a1.657 1.657 0 0 0-1.655-1.655h-2.207a1.657 1.657 0 0 0-1.655 1.655v1.103H8.414v-1.103a2.762 2.762 0 0 1 2.758-2.759h2.207a2.762 2.762 0 0 1 2.759 2.759v1.103ZM12.276 10.069a1.655 1.655 0 1 1 0 3.31 1.655 1.655 0 0 1 0-3.31Zm0-1.103a2.758 2.758 0 1 0 0 5.516 2.758 2.758 0 0 0 0-5.516ZM7.862 10.62H6.76A2.762 2.762 0 0 0 4 13.38v2.206h1.103V13.38a1.657 1.657 0 0 1 1.656-1.655h1.103v-1.103ZM7.862 5.103a1.655 1.655 0 1 1 0 3.31 1.655 1.655 0 0 1 0-3.31Zm0-1.103a2.759 2.759 0 1 0 0 5.517 2.759 2.759 0 0 0 0-5.517Z' />
    </g>
    <defs>
      <clipPath id='newTeam_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNewTeam;
